import { Box, Typography, Button, FormHelperText, Grid } from '@mui/material';
import { Theme, SystemStyleObject } from '@mui/system';
import { useFormContext } from 'react-hook-form';
import { TFormValues } from '../types.ts';
import { styles } from './styles.ts';
import { FormPhoneField } from '~/components/FormComponents/FormPhoneField.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FormCheckbox } from '~/components/FormComponents/FormCheckbox.tsx';

export const CreateFormContext = () => {
  const {
    clearErrors,
    formState: { errors, isSubmitting },
  } = useFormContext<TFormValues>();

  const handleCardAccessChange = (isChecked: boolean) => {
    if (isChecked) {
      clearErrors('atLeastOneCheckbox');
    }
  };

  const showAtLeastOneCheckboxError = !!errors.atLeastOneCheckbox;

  return (
    <Box sx={styles.container} data-testid="create-form-context">
      <Typography sx={styles.pageTitle} component="p" data-testid="createFormLabel">
        Оформити надання згоди на обробку персональних даних
      </Typography>

      <Grid
        container
        columnSpacing={2.5}
        rowSpacing={{ xs: 1.5, sm: 1 }}
        sx={[styles.fieldsWrapper as SystemStyleObject<Theme>, { alignItems: 'flex-start' }]}
      >
        <Grid size={{ xs: 12, sm: 6 }} sx={styles.fieldsWrapperItem}>
          <Box sx={styles.phoneFieldWrapper}>
            <FormPhoneField
              name="phone"
              label="Номер контактного телефону"
              dataTestId="phone-field"
            />
          </Box>
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }} sx={styles.fieldsWrapperItem}>
          <FormInput
            fullWidth
            name="email"
            label="Адреса електронної пошти"
            placeholder="Введіть адресу електронної пошти"
            inputProps={{
              'data-testid': 'text-field',
            }}
          />
        </Grid>
      </Grid>

      <Box sx={styles.checkboxWrapper}>
        <Typography sx={styles.purposeText} data-testid="purposeText">
          З якою метою надається згода:
        </Typography>

        <FormCheckbox
          name="cardAccess"
          label="Отримання карти – перепустки"
          onChange={handleCardAccessChange}
          formControlLabelProps={{
            sx: styles.checkboxLabel,
            'data-testid': 'cardAccessCheckboxLabel',
          }}
        />

        {showAtLeastOneCheckboxError && (
          <FormHelperText error data-testid="atLeastOneCheckboxError" sx={styles.errorText}>
            {errors.atLeastOneCheckbox?.message as string}
          </FormHelperText>
        )}
      </Box>
      <Button
        variant="contained"
        size="large"
        type="submit"
        disabled={isSubmitting}
        data-testid="submit-button"
      >
        Отримати посилання на згоду
      </Button>
    </Box>
  );
};
